export default {
  SMS: "sms",
  NET: "net",
  IOT: "iot"
};
